<template>
  <b-modal id="modal-edicao-pdf" dialog-class="modal-conta" size="lg" hide-footer :no-enforce-focus="true">
    <template slot="modal-header">
      <h5 class="modal-title">Editar pdf</h5>
      <button type="button" class="close" aria-label="Close" @click="$bvModal.hide('modal-edicao-pdf')">
        <span aria-hidden="true">&times;</span>
      </button>
    </template>
    <form>
      <h6><i class="fas fa-key"></i> Dados do pdf atual</h6>
      <div class="row" align="center">
        <div class="col-md-12 mb-3">
          <a :href="obterUrlS3(pdf)" target="_blank" class="visualizar-pdf"><i class="far fa-file-pdf"></i></a>
        </div>
      </div>
      <p></p>
      Link: <a target="_blank" :href="obterUrlS3(pdfEditar)">{{pdfEditar.url}}</a>
      <h6><i class="fas fa-key"></i> Upload de novo PDF</h6>
      <div class="row">
        <div class="col-12 col-md-12">
          <div class="form-group">
            <label for="pdfs">Adicionar novo PDF</label>
            <form-group :text="{ required: 'Obrigatório realizar o upload do pdf' }" class="input-group mb-3" :field="$v.pdf.pdfSelecionado">
              <b-form-file
                v-model="pdf.pdfSelecionado"
                placeholder="Escolha um PDF"
                drop-placeholder="Solte um arquivo aqui..."
                browse-text="Selecionar"
                accept="application/pdf"
              ></b-form-file>
            </form-group>
          </div>
        </div>
      </div>
      <div class="text-center">
        <div class="d-flex align-items-center justify-content-center mt-4 mb-4">
          <button class="btn btn-primary mr-3" type="button" @click="editarPdf">Salvar</button>
          <a href="javascript:void(0)" class="btn btn-secondary" @click="$bvModal.hide('modal-edicao-pdf')">Cancelar</a>
        </div>
      </div>
    </form>
  </b-modal>
</template>

<script>
import PdfAPI from '@/api/pdf-api'
import Swal from 'sweetalert2'
import { required } from 'vuelidate/lib/validators'
import FormGroup from '@/core/components/FormGroup'
import ResponseUtils from '@/core/util/response-utils'
import UrlUtils from '@/core/util/url-utils'

export default {
  name: 'ModalEdicaoPdf',
  components: {
    FormGroup
  },
  inheritAttrs: false,
  props: {
    pdfEditar: Object
  },
  data () {
    return {
      pdf: {
        id: null,
        url: null,
        pdfSelecionado: null,
        pasta: null
      },
      mostrarPdf: false
    }
  },

  mounted () {
    this.$root.$on('bv::modal::show', () => {
      this.$v.$reset()
      this.pdf = {
        id: this.pdfEditar.id,
        url: this.pdfEditar.url,
        pdfSelecionado: null,
        pasta: null
      }
    })
  },

  validations: {
    pdf: {
      pdfSelecionado: { required }
    }
  },

  methods: {
    show: function () {
      this.$bvModal.show('modal-edicao-pdf')
    },

    obterUrlS3: function (pdf) {
      return UrlUtils.obterUrlS3(pdf.url)
    },

    pdfErro () {
      this.mostrarPdf = false
    },

    editarPdf: function () {
      this.$v.pdf.$touch()
      if (!this.$v.pdf.$invalid) {
        const loader = this.$loading.show()

        this.pdf.url = this.pdf.pdfSelecionado.name

        PdfAPI.editar(this.pdf).then(data => {
          loader.hide()

          Swal.fire({
            icon: 'success',
            showCloseButton: true,
            text: 'PDF atualizado com sucesso!'
          }).then(() => {
            this.$bvModal.hide('modal-edicao-pdf')
            this.$emit('pdfEditado')
          })
        }).catch(error => ResponseUtils.handleError(error, loader))
      }
    }
  }
}
</script>
<style>
  div.modal-conta i.glyphicon-calendar{
    font-size: inherit;
  }
</style>
